import { Box, Typography, Button, useTheme } from "@mui/material";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export function FeedbackSuccessStep({ onFeedbackRestartRequested, onClose }) {
  const theme = useTheme();

  return (
    <Box sx={{ 
      p: 4, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: `${theme.palette.success.light}30`,
          color: theme.palette.success.main,
          mb: 3
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 48 }} />
      </Box>
      
      <Typography variant="h6" fontWeight="600" gutterBottom>
        Obrigado pelo seu feedback!
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4, maxWidth: 300 }}>
        Sua contribuição é muito importante para continuarmos melhorando nossa plataforma.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, width: '100%', maxWidth: 300 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={onClose}
          sx={{ borderRadius: 2 }}
        >
          Fechar
        </Button>
        <Button
          variant="contained"
          fullWidth
          onClick={onFeedbackRestartRequested}
          sx={{ borderRadius: 2 }}
        >
          Enviar outro
        </Button>
      </Box>
    </Box>
  );
}